import React from 'react'
import Link from 'gatsby-link'
import createReactClass from 'create-react-class'

import logo from './logo_cesartia.svg'

const store = require('store')

const IndexPage = createReactClass({
  getInitialState() {
    let local_state = store.get( 'state_active' ) || false;

    return {
      site_active: local_state
    }
  },
  componentDidMount() {
    setTimeout(() => {
      store.set( 'state_active', true );
      this.setState({ site_active: true })
    }, 4000);
  },

  logoClicked(e) {
    store.set( 'state_active', true );
    this.setState({ site_active: true })
  },

  render() {
    return (
      <div className="o__main">
        <div className={"m__menu-borders " + (this.state.site_active ? 'active' : '')}>
          <span id="vertical"></span>
          <span id="horizontal"></span>
        </div>

        <div className={"m__menu-blocks " + (this.state.site_active ? 'active' : '')}>
          <span>
            <Link to="/about">About</Link>
            <div className="lines"></div>
            <div className="lines"></div>
          </span>
          <span>
            <Link to="/portfolio">Portfolio</Link>
            <div className="lines"></div>
            <div className="lines"></div>
          </span>
          <span>
            <Link to="/contact">Contact</Link>
            <div className="lines"></div>
            <div className="lines"></div>
          </span>
          <span>
            <Link to="/">Coming Soon</Link>
            <div className="lines"></div>
            <div className="lines"></div>
          </span>
        </div>

        <div className={"m__logo-container " + (this.state.site_active ? 'active' : '')} onClick={this.logoClicked}>
          <img src={logo} alt="Logo" />

          <p>esartia</p>
        </div>
      </div>
    )
  }
})

export default IndexPage


// WEBPACK FOOTER //
// ./src/pages/index.js